module.exports = __webpack_public_path__ + "static/media/ic-pdf.5b2ce3ce.svg";